import Rating from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating";
import classNames from "classnames";
import { CardComponentProps } from "@~/types/types";
import { ProductLink } from "../__shared__/ProductLink/ProductLink";
import { SuffixType } from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating.types";
import { RatingsInline } from "./RatingsInline/RatingsInline";
import { RatingsCompact } from "./RatingsCompact/RatingsCompact";
import styles from "./Ratings.module.scss";

export const Ratings = ({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) => {
  if (!product.reviewSummary || !product.reviewSummary.numberOfReviews) {
    return null;
  }

  const isCompact = configProps?.size === "compact";
  const isInline = configProps?.size === "inline";
  const shouldHideRatingsOnMobile =
    configProps?.shouldHideRatingsOnMobile === true;

  const suffixType = (configProps?.suffixType || "count") as SuffixType;

  return (
    <ProductLink
      product={product}
      componentName="Ratings"
      tabIndex={-1}
      className={classNames({
        [styles.hideOnMobile!]: shouldHideRatingsOnMobile,
      })}
      opensQuickView={configProps?.productLinkOpensQuickView === true}
      quickViewConfig={configProps?.qvConfig as string | undefined}
    >
      <div
        className={classNames(styles.ratings, {
          [styles.ratings__compact!]: isCompact,
          [styles.ratings__inline!]: isInline,
        })}
      >
        {isCompact && (
          <RatingsCompact averageRating={product.reviewSummary.averageRating} />
        )}
        {isInline && (
          <RatingsInline
            averageRating={product.reviewSummary.averageRating}
            numberOfReviews={product.reviewSummary.numberOfReviews}
          />
        )}
        {!isCompact && !isInline && (
          <Rating
            size="large"
            suffixType={suffixType}
            rating={{
              averageRating: product.reviewSummary.averageRating,
              reviews: product.reviewSummary.numberOfReviews,
            }}
          />
        )}
      </div>
    </ProductLink>
  );
};
